import { render, staticRenderFns } from "./UsefulFiles.vue?vue&type=template&id=13585c90"
import script from "./UsefulFiles.vue?vue&type=script&lang=ts"
export * from "./UsefulFiles.vue?vue&type=script&lang=ts"
import style0 from "./UsefulFiles.vue?vue&type=style&index=0&id=13585c90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports